<template>
  <v-container>
    <v-row>
      <v-col
        cols="12"
      >
        <v-alert
          dense
          type="error"
          outlined
          text
          dismissible
          transition="slide-x-transition"
          class="py-0 text-uppercase"
          v-for="(item, index) in storeErrors"
          :key="index"
        >
          {{ item[0] }}
        </v-alert>
        <v-text-field
          label="Unit"
          v-model="unit"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
      >
        <v-text-field
          label="Description"
          v-model="description"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
      >
        <v-btn
          color="green"
          block
          @click="initStore"
        >Save</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  export default {
    name: 'vUnitCreate',
    data () {
      return {
        unit: null,
        description: null,
      }
    },
    computed: {
      ...mapState({
        storing: state => state.unit.storing,
        storeErrors: state => state.unit.storeErrors,
        storeSuccess: state => state.unit.storeSuccess,
      }),
    },
    watch: {
      storeSuccess (val) {
        if (val) {
          this.unit = null
          this.description = null
        }
      },
    },
    methods: {
      ...mapActions({
        store: 'unit/store',
      }),
      initStore () {
        this.store({
          unit: this.unit,
          description: this.description,
        })
      },
    },
  }
</script>
